// extracted by mini-css-extract-plugin
export default {"banner":"CookieConsent_banner__UHArL","content":"CookieConsent_content__XOCtT","buttons":"CookieConsent_buttons__usQFh"};